import React, { Component } from 'react'
import { Container, Typography, CardContent, Card, CardHeader, Button, Icon } from '@material-ui/core';
//import StatusBookingPayment from './partials/StatusBookingPayment'
//import PurchaseDetail from './../CheckoutPage/partials/PurchaseDetail'
import { NavLink as RouterLink } from "react-router-dom";

export default class Error extends Component {

    render() {
        const { content } = this.props

        return (
            <Container className={`container_thankyoupage error-page`} maxWidth="md" >
                <Card className="card_container">
                    <CardHeader
                        title={<Typography variant="h2">{content.statusMessage}</Typography>}
                    />
                    <CardContent>
                        <div className="inner-content">
                            <div className="mensaje-status text-center">
                                <Typography variant="h1" className="title-message">{content.title}</Typography>
                            </div>
                            {content.messages && content.messages.length > 0 &&
                                <div className="paper text-center paper-outlined info-status-reserva">
                                    <div className="bloq-estados-transaccion">
                                        {content.messages.map((message, id) => 
                                            <Typography key={id}>{message.item}</Typography>
                                        )} 
                                        <Button startIcon={<Icon>search</Icon>} className="mt-1" variant="contained" color="primary"
                                        component={RouterLink}
                                        to={{pathname:`/${this.props.tokenClient}/trenes/`}}
                                         >
                                            Buscar
                                        </Button>
                                    </div>
                                </div>
                            }
                            <br/>
                        </div>
                    </CardContent>
                </Card>  
            </Container>
    
        )
    }
}